module.exports = __webpack_public_path__ + "3d40d55c4ee7bcf95ac9edb4a8c1116b.svg";